import { Badge, Tooltip } from '@customerio/pluma-components/react';
import { stateColor, stateDescription, stateLabel } from '../catalog';

type DeliveryStateTagProps = {
  /** The delivery state to display (typically `getDisplayState(delivery)`). */
  state: string;
  /** Channel value (`action_type` minus `_action`) — selects the `delivered` copy. */
  channel?: string;
};

/**
 * Colored status label for a delivery state, with a hover tooltip explaining
 * the state. Ported from the Ember `<delivery-state-tag>` + `state-label-map`:
 * a bare colored `Label`, no status-indicator dot (Ember's tag defaults
 * `showStatusIndicator` to false and no caller opts in).
 */
export function DeliveryStateTag({ state, channel }: DeliveryStateTagProps) {
  const description = stateDescription(state, channel);
  const label = <Badge color={stateColor(state)}>{stateLabel(state)}</Badge>;

  if (description == null) return label;

  return (
    <Tooltip content={description} placement="top">
      {label}
    </Tooltip>
  );
}
